import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import Toggle from 'react-toggle';
import { showModal, hideModal } from '../../../actions/ModalActions';
import { updateWedding, updateWeddingAccount, toggleWebsite } from '../../../actions/WeddingActions';
import { RenderField, RenderTextareaField, RenderSubmitButton } from '../../common/form';
import * as Validations from '../../common/form/commonValidations';


class WebsiteSettings extends Component {
  constructor(props) {
    super(props);

    this.togglePasscode = this.togglePasscode.bind(this);
    this.toggleRsvpRequests = this.toggleRsvpRequests.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.handleSuccess = this.handleSuccess.bind(this);
    this.toggleSearchable = this.toggleSearchable.bind(this);
    this.toggleWebsitePublish = this.toggleWebsitePublish.bind(this);

    this.state = {
      successfulSave: false,
    };
  }

  onSubmit(values) {
    const { handleSubmit } = this.props;
    const submitReturn = handleSubmit(values);
    submitReturn.then(this.handleSuccess);
  }

  toggleWebsitePublish() {
    const { onTogglePublish, openHidePagesModal, account } = this.props;
    if (account.published) {
      onTogglePublish(false);
      this.toggleSearchable({ enable_search_engine: false, enable_search_zola: false });
    } else {
      openHidePagesModal();
    }
  }

  togglePasscode(e) {
    const { account, onTogglePasscode, hasPasscode, onSubmit } = this.props;
    onTogglePasscode(hasPasscode);
    if (!e.target.checked) {
      const updatedAccount = Object.assign({}, account, { enable_passcode: false });
      onSubmit(updatedAccount);
    }
  }

  toggleRsvpRequests() {
    const { account, onToggleRsvpRequests, rsvpRequestEnabled, onUpdateWeddingAccount } = this.props;
    onToggleRsvpRequests(rsvpRequestEnabled);
    if (rsvpRequestEnabled) {
      const weddingRequest = Object.assign({}, account, { enable_rsvp_requests: false });
      onUpdateWeddingAccount(weddingRequest);
    } else if (!rsvpRequestEnabled) {
      const weddingRequest = Object.assign({}, account, { enable_rsvp_requests: true });
      onUpdateWeddingAccount(weddingRequest);
    }
  }

  toggleSearchable(searchableSettings) {
    const { account, wedding, onUpdateWedding } = this.props;
    if (account.published) {
      const weddingRequest = Object.assign({}, wedding, searchableSettings);
      onUpdateWedding(weddingRequest);
    }
  }

  handleSuccess() {
    // TODO: factor this out out somewhere
    this.setState({ successfulSave: true });
    setTimeout(() => this.setState({ successfulSave: false }), 1000);
  }

  render() {
    const { account, wedding, theme, hasPasscode, valid, pristine, closeModal, rsvpRequestEnabled, themeGroupTitle } = this.props;
    const { successfulSave } = this.state;
    return (
      <div id="website-settings-modal">
        <div className="modal-header">
          <h3>Edit Website Settings</h3>
        </div>
        <div className="modal-body">
          <div className="modal-body-section visibility-settings">
            <div className="row margin-bottom">
              <div className="col-xs-9">
                <div className="with-tooltip" data-tooltip="Ready to show off your website? Switch the toggle to &quot;Yes&quot; and anyone will be able to see it. Not ready yet? Keep the toggle on &quot;No.&quot;">
                  <div className="title">
                    <span>Make Website Visible</span>
                  </div>
                  <div className="subtitle text-muted">
                    <span>Control search settings when your website is visible.</span>
                  </div>
                </div>
              </div>
              <div className="col-xs-3">
                <div className="body">
                  <Toggle
                    checked={account.published}
                    onChange={this.toggleWebsitePublish}
                    className="toggle-small toggle-red"
                    icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                  />
                </div>
              </div>
            </div>
            <div className={`searchable-settings ${!account.published && 'grayed-out'}`}>
              <div className="row margin-bottom">
                <div className="col-xs-offset-1 col-xs-8">
                  <div className="with-tooltip" data-tooltip="Control if guests can find your website by searching you and your partner&#39;s names on Google or other search engines.">
                    <div className="title">
                      <span>Searchable on search engines</span>
                    </div>
                    <div className="subtitle text-muted">
                      <span>This may take up to 10 days. <Link to="https://help.zola.com/hc/en-us/articles/115002148232-How-can-I-control-if-my-website-is-searchable-on-search-engines-ex-Google-or-Zola-" target="_blank" rel="noopener noreferrer" onClick={closeModal} className="text-button">Here&#39;s why &rsaquo;</Link></span>
                    </div>
                  </div>
                </div>
                <div className="col-xs-3">
                  <div className="body">
                    <Toggle
                      checked={wedding.enable_search_engine}
                      onChange={() => this.toggleSearchable({ enable_search_engine: !wedding.enable_search_engine })}
                      className="toggle-small"
                      icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                    />
                  </div>
                </div>
              </div>
              <div className="row margin-bottom">
                <div className="col-xs-offset-1 col-xs-8">
                  <div className="with-tooltip" data-tooltip="Control if guests can find your website by searching your and your partner's names on Zola.">
                    <div className="title">
                      <span>Searchable on Zola</span>
                    </div>
                  </div>
                </div>
                <div className="col-xs-3">
                  <div className="body">
                    <Toggle
                      checked={wedding.enable_search_zola}
                      onChange={() => this.toggleSearchable({ enable_search_zola: !wedding.enable_search_zola })}
                      className="toggle-small"
                      icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-body-section passcode-settings">
            <div className="row margin-bottom">
              <div className="col-xs-9">
                <div className="with-tooltip" data-tooltip="Want to make your website visible to guests, but not the general public? Enable this feature, then only people with the password can see your website.">
                  <div className="title">
                    <span>Password Protect</span>
                  </div>
                </div>
              </div>
              <div className="col-xs-3">
                <div className="body">
                  <Toggle
                    checked={hasPasscode}
                    onChange={e => this.togglePasscode(e)}
                    className="toggle-small"
                    icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                  />
                </div>
              </div>
            </div>
            {hasPasscode && (
              <form onSubmit={this.onSubmit}>
                <div className="row">
                  <div className="col-xs-offset-1 col-xs-9">
                    <div className="title">
                      <span>Enter Password <span className="text-danger danger-asterisk">*</span></span>
                    </div>
                    <div className="body">
                      <Field
                        type="text"
                        component={RenderField}
                        name="passcode"
                        id="passcode"
                        placeholder="Password"
                        validate={[Validations.REQUIRED, Validations.MAX_LENGTH_20]}
                        maxChars={20}
                        required
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-xs-offset-1 col-xs-9">
                    <div className="title">
                      <span>Instructions for guests</span>
                    </div>
                    <div className="body">
                      <Field
                        hideFormGroup
                        component={RenderTextareaField}
                        name="passcode_instructions"
                        placeholder="If you don't know the password, check your invitation. Otherwise, reach out to Jen Foster."
                        id="passcode-note"
                      />
                    </div>
                  </div>
                </div>
                <div className="col-xs-offset-1">
                  <RenderSubmitButton hideFormGroup valid={valid} pristine={pristine} disableWhenPristine showSuccess={successfulSave} />
                </div>
              </form>
            )}
            <br />
            <div className="row">
              <div>
                <div className="col-xs-9">
                  <div>
                    <div className="title">
                      <span>Let Guests Request RSVP Access</span>
                    </div>
                    <div className="subtitle text-muted">
                      <span>Not sure what to do? <Link to="https://help.zola.com/hc/en-us/sections/115000790951-RSVP" target="_blank" rel="noopener noreferrer" onClick={closeModal} className="text-button">Learn More &rsaquo;</Link></span>
                    </div>
                  </div>
                </div>
                <div className="col-xs-3">
                  <div className="body">
                    <Toggle
                      checked={rsvpRequestEnabled}
                      onChange={() => this.toggleRsvpRequests({ enable_rsvp_requests: !wedding.enable_rsvp_requests })}
                      className="toggle-small"
                      icons={{ checked: <span className="toggle-label checked">Yes</span>, unchecked: <span className="toggle-label unchecked">No</span> }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal-body-section theme-settings">
            <div className="modal-section-title theme-settings-header">
              <h4>Selected Design: {themeGroupTitle}</h4>
            </div>
            <div className="modal-section-description">
              Want to select a different design? You can easily switch to a new one and we&#39;ll transfer all your information over. <Link to="/wedding/manage/website/designs" className="text-button" onClick={closeModal}>See designs &rsaquo;</Link>
            </div>
            <div className="selected-design">
              <div className="preview gradient" style={{ backgroundImage: `url(${theme.preview_images[0]})` }}>
                <div className="edit-pages-link">
                  <Link to="/wedding/manage/website/pages/home" onClick={closeModal} className="btn btn-primary btn-wide">Edit Website Pages</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

WebsiteSettings.propTypes = {
  wedding: PropTypes.shape({}),
  account: PropTypes.shape({}),
  theme: PropTypes.shape({}),
  hasPasscode: PropTypes.bool,
  valid: PropTypes.bool,
  pristine: PropTypes.bool,
  openHidePagesModal: PropTypes.func,
  onUpdateWedding: PropTypes.func,
  onTogglePublish: PropTypes.func,
  onTogglePasscode: PropTypes.func,
  handleSubmit: PropTypes.func,
  onSubmit: PropTypes.func,
  closeModal: PropTypes.func,
  rsvpRequestEnabled: PropTypes.bool,
  onToggleRsvpRequests: PropTypes.func,
  onUpdateWeddingAccount: PropTypes.func,
  themeGroupTitle: PropTypes.string
};

const selector = formValueSelector('websiteSettingsForm');

const mapStateToProps = (state, ownProps) => ({
  wedding: state.wedding.wedding,
  account: state.wedding.account,
  theme: state.wedding.theme,
  hasPasscode: !!selector(state, 'enable_passcode'),
  rsvpRequestEnabled: !!selector(state, 'enable_rsvp_requests'),
  initialValues: ownProps.enablePasscode ? Object.assign({}, state.wedding.account, { enable_passcode: true }) : state.wedding.account,
  themeGroupTitle: state.wedding.themeGroupTitle
});

const mapDispatchToProps = dispatch => ({
  onSubmit: (weddingAccountRequest) => {
    const form = Object.assign({}, weddingAccountRequest);
    if (!form.enable_passcode) {
      form.passcode = undefined;
      form.passcode_instructions = undefined;
    }
    return dispatch(updateWeddingAccount(form));
  },
  onUpdateWeddingAccount: weddingRequest => dispatch(updateWeddingAccount(weddingRequest)),
  openHidePagesModal: () => dispatch(showModal('HIDE_PAGES', { afterPublish: () => dispatch(showModal('WEBSITE_SETTINGS', {}, { size: 'md' })) }, { size: 'md' })),
  onUpdateWedding: weddingRequest => dispatch(updateWedding(weddingRequest)),
  onTogglePublish: publish => dispatch(toggleWebsite(publish)),
  onTogglePasscode: enable => dispatch(change('websiteSettingsForm', 'enable_passcode', !enable)),
  onToggleRsvpRequests: enable => dispatch(change('websiteSettingsForm', 'enable_rsvp_requests', !enable)),
  closeModal: () => dispatch(hideModal()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(reduxForm({
  form: 'websiteSettingsForm'
})(WebsiteSettings));



// WEBPACK FOOTER //
// ./src/components/manage/website/WebsiteSettingsModal.jsx